import { typeof as _typeof, slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useEffect } from 'react';

var WindowSize = function WindowSize() {
  var isClient = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object';
  var _useState = useState({
      width: 0,
      height: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    windowSize = _useState2[0],
    setWindowSize = _useState2[1];
  useEffect(function () {
    if (!isClient) {
      return false;
    }
    function getSize() {
      return {
        width: isClient ? window.innerWidth : 0,
        height: isClient ? window.innerHeight : 0
      };
    }
    function handleResize() {
      setWindowSize(getSize());
    }
    handleResize();
    window.addEventListener('resize', handleResize);

    // Cleanup callback to be run after hook is unmounted
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, [isClient]);
  return windowSize;
};
var useWindowSize = WindowSize;

export { useWindowSize as default };
//# sourceMappingURL=useWindowSize.js.map
